import { render, staticRenderFns } from "./EtatLocatifFormItem.vue?vue&type=template&id=08287b8c&"
import script from "./EtatLocatifFormItem.vue?vue&type=script&lang=ts&"
export * from "./EtatLocatifFormItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports